export default import.meta.ROLLDOWN_FILE_URL_V3IS0RK33loChjoSkOOTjQ